import {useDispatch, useSelector} from 'react-redux';
import {v4 as uuidv4} from 'uuid';
import React, {useCallback, useEffect} from 'react';
import {roomProtectionSelector} from '../../../../../store/selectors/roomProtection.selector';
import {getAnonymousPresenterHash, setAnonymousPresenterHash} from '../../../../../util/token.utils';
import {usePresentationParams} from '../../../../../hooks/usePresentationParams';
import {findRoomByIdAction} from '../../../../../store/actions/roomRunFile.actions';
import AdminLoginModal from '../../../../../components/presentationView/parts/components/AdminAuthModal';
import {GuestCredentials} from '../../../../../components/presentationView/parts/components/GuestModal';

function AdminCredentialsModal(): JSX.Element {
    const {roomId, params, presenterCode} = usePresentationParams();
    const dispatch = useDispatch();

    const protection = useSelector(roomProtectionSelector);

    // Hash key for anonymous presenter
    let hash = getAnonymousPresenterHash();
    if (!!presenterCode && protection?.isRoomPresenterAnonymous) {
        if (!hash) {
            hash = uuidv4();
            setAnonymousPresenterHash(hash);
        }
    }

    useEffect(() => {
        if (protection?.isRoomPresenterAnonymous && hash && roomId)
            dispatch(findRoomByIdAction(roomId, undefined, params, hash, presenterCode || undefined));
    }, [dispatch, hash, params, presenterCode, protection?.isRoomPresenterAnonymous, roomId]);

    const findPresentation = useCallback(
        (cr?: GuestCredentials): void => {
            if (roomId) {
                dispatch(findRoomByIdAction(roomId, cr, params, hash, presenterCode || undefined));
            }
        },
        [dispatch, hash, params, presenterCode, roomId]
    );

    return (
        <AdminLoginModal
            isRoomAdmin={!!presenterCode}
            findPresentation={findPresentation}
            isRoomPresenterAnonymous={protection?.isRoomPresenterAnonymous}
        />
    );
}

export default AdminCredentialsModal;
